module.exports = __webpack_public_path__ + "4828656dc640bf98a8037477cc31d9a8.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/termine/vercetti.jpg
// module id = 591
// module chunks = 0